import { render, staticRenderFns } from "./RequiringAccessToInformation.vue?vue&type=template&id=231b40ab"
import script from "./RequiringAccessToInformation.vue?vue&type=script&lang=ts"
export * from "./RequiringAccessToInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports